import React, { Component } from "react";
import hero1 from '../images/slider/slide-1.jpg';
import hero2 from '../images/slider/slide-2.jpg';
import hero3 from '../images/slider/slide-3.jpg';
import hero4 from '../images/slider/slide-4.jpg';


class CustomCarousel extends Component {
    constructor(props) {
        super(props);
        this.state = {
            currentIndex: 0, // Índice de la imagen actual
        };
        this.images = [hero2, hero1, hero3, hero4]; // Lista de imágenes
        this.interval = null; // Intervalo para el cambio automático
    }

    componentDidMount() {
        // Inicia el cambio automático de imágenes cada 3 segundos
        this.interval = setInterval(this.nextSlide, 3000);
    }

    componentWillUnmount() {
        // Limpia el intervalo cuando el componente se desmonta
        clearInterval(this.interval);
    }

    nextSlide = () => {
        // Cambia a la siguiente imagen
        this.setState((prevState) => ({
            currentIndex: (prevState.currentIndex + 1) % this.images.length,
        }));
    };

    render() {
        const { currentIndex } = this.state;

        // Estilos en línea
        const styles = {
            carouselContainer: {
                width: '100%',
                height: '50vh', // Altura por defecto para móviles
                position: 'relative',
                overflow: 'hidden',
            },
            carouselContainerMd: {
                height: '85vh', // Altura para pantallas medianas y superiores
            },
            slide: {
                width: '100%',
                height: '100%',
                position: 'absolute',
                top: 0,
                left: 0,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                transition: 'opacity 1s ease-in-out', // Transición suave
                opacity: 0, // Inicialmente invisible
            },
            activeSlide: {
                opacity: 1, // Visible
            },
        };

        return (
            <div 
                className="custom-carousel" 
                style={{
                    ...styles.carouselContainer,
                    ...(window.innerWidth >= 768 && styles.carouselContainerMd) // Aplica 70vh en pantallas md y superiores
                }}
            >
                {this.images.map((image, index) => (
                    <div
                        key={index}
                        style={{
                            ...styles.slide,
                            ...(index === currentIndex && styles.activeSlide), // Muestra solo la imagen activa
                            backgroundImage: `url(${image})`,
                        }}
                    ></div>
                ))}
            </div>
        );
    }
}

export default CustomCarousel;